module.exports = __webpack_public_path__ + "img/39.f42ee88a.png";